import { useBaseListView } from '@/common/view/useBaseListView';
import { useCrudActions } from '@/common/view/useCrudActions';
import { arenaService } from '@/services/arena';
import { reactive } from 'vue';
import { useRoute } from 'vue-router';

export function useArenaItemMedal() {
    const route = useRoute();

    const model = reactive({
        arenaId: route.params.id as string,
        linkedItems: [],
        unlinkedItems: []
    });

    const { list, total, fetchList } = useBaseListView({
        request: arenaService.medal.getLinked,
        paramsBuilder: () => ({ arenaId: model.arenaId }),
        hooks: {
            onSuccess: () => {
                model.linkedItems = [];
                model.unlinkedItems = [];
                list.value.forEach(medal => {
                    if (medal.linkedArena) {
                        model.linkedItems.push(medal.id);
                    } else {
                        model.unlinkedItems.push(medal.id);
                    }
                });
            }
        }
    });

    const { confirmAndExecute } = useCrudActions();
    const actions = {
        link: confirmAndExecute({
            confirmMessage: 'Are you want to link this medal?',
            request: arenaService.medal.link,
            onSuccess: () => fetchList()
        }),
        unlink: confirmAndExecute({
            confirmMessage: 'Are you want to unlink this medal?',
            request: arenaService.medal.unlink,
            onSuccess: () => fetchList()
        }),
        linkAll: confirmAndExecute({
            confirmMessage: 'Are you want to link all medals?',
            request: () => arenaService.medal.link(model.arenaId, model.unlinkedItems.join(',')),
            onSuccess: () => fetchList()
        }),
        unlinkAll: confirmAndExecute({
            confirmMessage: 'Are you want to unlink all medals?',
            request: () => arenaService.medal.unlink(model.arenaId, model.linkedItems.join(',')),
            onSuccess: () => fetchList()
        })
    };

    return { model, list, total, fetchList, actions };
}
